import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Folder } from '@app/models';
import { ErrorHandlerService, FolderService } from '@app/services';

@Component({
  selector: 'app-folders-list-boxes',
  templateUrl: './folders-list-boxes.component.html',
  styleUrls: ['./folders-list-boxes.component.scss'],
  standalone: false
})
export class FoldersListBoxesComponent implements OnInit {
  @Input() folders: Folder[];
  @Input() hideDropdownMenu: boolean;
  @Input() hidePagination: boolean;
  @Input() isEditorParent = false;
  @Input() memberId: string = null;
  @Output() updateClick = new EventEmitter<Folder>();
  @Output() shareClick = new EventEmitter<Folder>();
  @Output() folderClick = new EventEmitter<Folder>();
  @Output() deleteClick = new EventEmitter<Folder>();
  @Output() loadPageClick = new EventEmitter();

  isEditorMap: Record<string, boolean> = {};

  constructor(
    private folderService: FolderService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {}

  getFolderPath(id: string) {
    let path = `/pastas/${id}`;
    if (!!this.memberId) {
      path += `/organizacao/${this.memberId}`;
    }

    return path;
  }

  loadFolderEditor(id: string) {
    if (!id) return;

    if (!Object.keys(this.isEditorMap).includes(id)) {
      this.folderService.folder({ id }, 'cache-first').subscribe({
        next: folder => (this.isEditorMap[id] = folder.is_editor),
        error: error => this.errorHandlerService.handle(error)
      });
    }
  }
}
